<template>
  <div style="display: inline-block">
    <el-button icon=""
               type="primary"
               size="mini"
               @click="openDialog">添加客户资源申请
    </el-button>

    <el-dialog :visible.sync="visible"
               :modal-append-to-body="modal"
               title="添加客户资源申请"
               width="50%"
    >
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="380px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <div style="margin: 10px">
              <el-button type="danger"
                         size="mini"
                         @click="onAddDetail()"
                         style="margin-bottom: 30px">添加
              </el-button>
              <el-row>
                <el-col :span="10" class="col-center">修改账号</el-col>
                <el-col :span="13" :offset="1" class="col-center">客户资源分配</el-col>
              </el-row>
              <br/>
              <el-row v-for="(detailItem, itemIndex) in form.detail"
                      :key="itemIndex"
                      style="margin-top:5px">
                <!--账号-->
                <el-col
                  :span="9">
                  <remote-select
                    class="width-max"
                    clearable
                    id-key="id"
                    keyword-key="name"
                    label-key="name"
                    value-key="id"
                    placeholder="请输入账号名称搜索"
                    v-model="detailItem.admin_id"
                    @change="onChangeAdminId(itemIndex)"
                    :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype_not: [1, 5]}))"
                    :find-request="getPlatformUsersDetail">
                  </remote-select>
                </el-col>

                <!--客户资源-->
                <el-col :span="12" :offset="1">
                  <remote-select :disabled="!detailItem.admin_id"
                    class="width-max"
                    clearable
                    multiple
                    id-key="number"
                    label-key="name"
                    value-key="id"
                    placeholder="请输入客户名称/编号搜索"
                    v-model="detailItem.customerid"
                    :query-request="(_)=>getCustomerTable(Object.assign(_, {type: 'all'}))"
                    :find-request="getCustomerDetail">
                  </remote-select>
                </el-col>
                <el-col :span=1 :offset="1">
                  <el-button type="danger"
                             size="mini"
                             icon="el-icon-delete"
                             @click="onDelItem(itemIndex)">
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </div>

        </div>
        <el-form-item style="margin-top: 40px">
          <el-button @click="visible = false">取消
          </el-button>
          <el-button type="primary"
                     native-type="submit">确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { formRules } from '../permission-apply.rules.js'
import selectRemote from '@core/mixins/selectRemote'

export default {
  mixins: [selectRemote],
  components: {},
  data () {
    return {
      visible: false,
      modal: false,
      load: false,
      id: 0,
      formRules,
      form: {
        detail: [
          {
            admin_id: 0,
            customerid: [],
          }
        ],
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex', 'getCustomerDetail', 'getPlatformUsersDetail']),
    openDialog () {
      this.form.detail = [
        {
          admin_id: '',
          customerid: [],
        }
      ]
      this.visible = true
    },
    onAddDetail () {
      let params = {
        admin_id: 0,
        customerid: [],
      }
      this.form.detail.push(params)
    },
    onDelItem (index) {
      if (this.form.detail.length === 1) {
        this.$alert('请至少添加一个', '提示', {
          type: 'error',
        })
      } else {
        this.form.detail.splice(index, 1)
      }
    },
    onChangeAdminId (index) {
      if (this.form.detail[index] && this.form.detail[index].admin_id) {
        let id = this.form.detail[index].admin_id
        request.common('getPermissionApplyCustomerInfo', {id: id}).then(({data}) => {
          if (data.length !== 0) {
            this.form.detail[index].customerid = data
          }
        }).catch(() => {
          this.form.detail[index].customerid = []
        })
      } else {
        this.form.detail[index].customerid = []
      }
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (!this.checkSubmit()) return
        if (valid) {
          this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    create () {
      request.common('createPermissionApplyData', this.getForm()).then((res) => {
        this.visible = false
        this.$router.go(0)
      })
    },

    // 检查活动通用字段
    checkSubmit () {
      if (this.form.detail.length < 1) {
        this.$message.error('请至少添加一个申请')
        return false
      }

      for (let i = 0; i < this.form.detail.length; i++) {
        if (this.form.detail[i].admin_id <= 0) {
          this.$message.error('修改账号为空')
          return false
        }
        if (this.form.detail[i].customerid.length <= 0) {
          this.$message.error('客户资源分配为空')
          return false
        }
      }

      return true
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/permission-apply/components/PermissionApplyForm.vue